import { forwardRef } from 'react';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DragHandleIcon = styled(UIIcon).withConfig({
  displayName: "ResizableDragHandle__DragHandleIcon",
  componentId: "sc-6dp9nk-0"
})(["padding:0 1px;transform:rotate(90deg) translate(0,-6px);"]);
const DragHandleIconWrapper = styled.div.withConfig({
  displayName: "ResizableDragHandle__DragHandleIconWrapper",
  componentId: "sc-6dp9nk-1"
})(["display:flex;justify-content:center;margin-top:1px;height:12px;"]);
const DragHandleBar = styled.div.withConfig({
  displayName: "ResizableDragHandle__DragHandleBar",
  componentId: "sc-6dp9nk-2"
})(["height:3px;width:100%;background-color:", ";opacity:0;"], CALYPSO_DARK);
const DragHandleAffordance = styled.div.withConfig({
  displayName: "ResizableDragHandle__DragHandleAffordance",
  componentId: "sc-6dp9nk-3"
})(["&:hover{", "{opacity:1;}}&&&{", "{", " ", "}}"], DragHandleBar, DragHandleBar, ({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'isPreview' does not exist on type 'Pick<... Remove this comment to see the full error message
  isPreview
}) => isPreview ? `opacity: 1` : '', ({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'hide' does not exist on type 'Pick<Detai... Remove this comment to see the full error message
  hide
}) => hide ? `opacity: 0` : '');
const DragHandleWrapper = styled.div.withConfig({
  displayName: "ResizableDragHandle__DragHandleWrapper",
  componentId: "sc-6dp9nk-4"
})(["margin-top:-2px;position:absolute;width:100%;cursor:ns-resize;z-index:1;"]);
export const ResizableDragHandle = /*#__PURE__*/forwardRef((props, ref) => {
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    _jsx(DragHandleWrapper, Object.assign({}, props, {
      ref: ref,
      children: /*#__PURE__*/_jsxs(DragHandleAffordance, Object.assign({}, props, {
        children: [/*#__PURE__*/_jsx(DragHandleBar, {}), /*#__PURE__*/_jsxs(DragHandleIconWrapper, {
          children: [/*#__PURE__*/_jsx(DragHandleIcon, {
            name: "dragHandle",
            size: 12
          }), /*#__PURE__*/_jsx(DragHandleIcon, {
            name: "dragHandle",
            size: 12
          }), /*#__PURE__*/_jsx(DragHandleIcon, {
            name: "dragHandle",
            size: 12
          })]
        })]
      }))
    }))
  );
});
ResizableDragHandle.displayName = 'ReplyEditorDragHandle';
export default ResizableDragHandle;